import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Bridge } from './components/Bridge';
import { Authority } from './components/Authority';
import { ProductTomos } from './components/ProductTomos';
import { BeforeAfter } from './components/BeforeAfter';
import { WhoIsItFor } from './components/WhoIsItFor';
import { Bonuses } from './components/Bonuses';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { ValueSummary } from './components/ValueSummary';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: MetaPixelFunction;
  loaded?: boolean;
  version?: string;
};
type MetaPixelWindow = Window & {
  fbq?: MetaPixelFunction;
  _fbq?: MetaPixelFunction;
};
export function App() {
  useEffect(() => {
    if (!document.querySelector('link[data-mp-preconnect="cdn"]')) {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://cdn.magicpatterns.com';
      preconnect.crossOrigin = 'anonymous';
      preconnect.setAttribute('data-mp-preconnect', 'cdn');
      document.head.appendChild(preconnect);
    }
    const pixelId = '1692903235058105';
    const pixelWindow = window as MetaPixelWindow;
    if (pixelWindow.fbq) {
      pixelWindow.fbq('track', 'PageView');
      return;
    }
    const fbq: MetaPixelFunction = (...args) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
        return;
      }
      fbq.queue?.push(args);
    };
    pixelWindow.fbq = fbq;
    if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', pixelId);
    fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-brand-dark font-sans text-brand-cream selection:bg-brand-accent selection:text-brand-darker" data-id="element-0" data-mp="d4e5zu7z1ex8">
      <Hero data-id="element-1" data-mp="86mev2f5hwu3" />
      <SocialProof data-id="element-2" data-mp="86w3omoglxy7" />
      <Bridge data-id="element-3" data-mp="83i39jzcvyte" />
      <Authority data-id="element-4" data-mp="83qivjmv5i8a" />
      <ProductTomos data-id="element-5" data-mp="3gl4qtf87pwiz" />
      <BeforeAfter data-id="element-6" data-mp="3gmfw5jhb3cc7" />
      <WhoIsItFor data-id="element-7" data-mp="3glwc9x83idvj" />
      <Bonuses data-id="element-8" data-mp="3gja6o34rm8fy" />
      <PricingSection data-id="element-9" data-mp="3bmbe3p0r29jv" />
      <Guarantee data-id="element-10" data-mp="3bmtgl3e09k08" />
      <ValueSummary data-id="element-11" data-mp="3bncorsdusu12" />
      <FAQ data-id="element-12" data-mp="3bnus18yxo8ih" />
      <FinalCTA data-id="element-13" data-mp="3bk70uggyny6x" />
      <Footer data-id="element-14" data-mp="3qb7i9azor2f7" />
    </main>;
}